import React from 'react';
import { map } from 'lodash';

import EmployeeQuotes from '../../components/blocks/EmployeeQuotes/EmployeeQuotes';
import UseCasesModule from '../../components/common/UseCasesModule/UseCasesModule';
import HomeownerQuotes from '../../components/home/HomeownerQuotes/HomeownerQuotes';
import PricingTable from '../comparisonTables/PricingTable/PricingTable';
import QualificationTable from '../comparisonTables/QualificationTable/QualificationTable';
import WhatHomeownersAreSayingBlock from '../resources/WhatHomeownersAreSayingBlock/WhatHomeownersAreSayingBlock';
import ShareYourStoryBlock from '../stories/ShareYourStoryBlock/ShareYourStoryBlock';
import Trustpilot from '../trustpilot/Trustpilot';
import AmountCalculatorBlock from './AmountCalculatorBlock/AmountCalculatorBlock';
import AwardsBlock from './AwardsBlock/AwardsBlock';
import CardGroupBlockController from './CardGroupBlock/CardGroupBlockController';
import CTABlock from './CTABlock/CTABlock';
import DebtCalculatorBlock from './DebtCalculatorBlock/DebtCalculatorBlock';
import FAQList from './FAQList/FAQList';
import FormBlock from './FormBlock/FormBlock';
import LogoListBlock from './LogoListBlock/LogoListBlock';
import MeetTheTeamBlock from './MeetTheTeamBlock/MeetTheTeamBlock';
import ThreeImageBlock from './ThreeImageBlock/ThreeImageBlock';
import TimelineBlock from './TimelineBlock/TimelineBlock';
import VideoBlock from './VideoBlock/VideoBlock';
import WhoWeAreBlock from './WhoWeAreBlock/WhoWeAreBlock';
import WhyHometapCards from './WhyHometapCards/WhyHometapCards';

const Block = ({ data }) => {
  const fields = data.block?.blockFields;
  if (!fields) return null;
  let block;
  const staticFields = fields.staticBlock && fields.staticBlock[0];
  switch (fields.blockType) {
    case 'debt_calculator':
      block = <DebtCalculatorBlock data={fields.debtCalculator[0]} />;
      break;
    case 'amount_calculator':
      block = <AmountCalculatorBlock data={fields.amountCalculator[0]} />;
      break;
    case 'who_we_are':
      block = <WhoWeAreBlock {...data.block?.blockFields.whoWeAreBlock} />;
      break;
    case 'employee_quotes':
      block = <EmployeeQuotes quotes={data.block?.blockFields.employeeQuotesBlock} />;
      break;
    case 'meet_the_team_block':
      block = <MeetTheTeamBlock data={data} />;
      break;
    case 'centered_cta_block':
      block = <CTABlock data={data} />;
      break;
    case 'card_group_block':
      block = <CardGroupBlockController data={data} />;
      break;
    case 'awards_block':
      block = <AwardsBlock awards={fields.awardsBlock} />;
      break;
    case 'three_image_block':
      block = <ThreeImageBlock images={map(fields.threeImageBlockFields, 'image')} />;
      break;
    case 'faq_list':
      block = <FAQList data={data} />;
      break;
    case 'video_block':
      block = <VideoBlock data={data} />;
      break;
    case 'form_block':
      block = <FormBlock data={data} />;
      break;
    case 'logo_list':
      block = (
        <LogoListBlock
          title={fields.logoListBlock?.title}
          theme={fields.theme}
          logos={map(fields.logoListBlock?.logos, 'logo')}
        />
      );
      break;
    case 'use_case':
      block = <UseCasesModule {...data?.block.blockFields.useCaseCardsBlock[0]} />;
      break;
    case 'static_block':
      if (staticFields.componentType === 'ShareYourStoryBlock') {
        block = <ShareYourStoryBlock />;
      } else if (staticFields.componentType === 'WhatHomeownersAreSaying') {
        block = <WhatHomeownersAreSayingBlock />;
      } else if (staticFields.componentType === 'Trustpilot') {
        block = <Trustpilot />;
      } else if (staticFields.componentType === 'WhyHometapCards') {
        block = <WhyHometapCards />;
      } else if (staticFields.componentType === 'HomeownersLoveHometap') {
        block = (
          <HomeownerQuotes
            title="Homeowners love working with Hometap"
            text="(Thank you, homeowners. The feeling is mutual.)"
            buttonLabel="View all homeowner stories"
            buttonLink="/stories/"
          />
        );
      } else if (staticFields.componentType === 'Timeline') {
        block = <TimelineBlock />;
      } else if (staticFields.componentType === 'QualificationTable') {
        block = <QualificationTable />;
      } else if (staticFields.componentType === 'PricingTable') {
        block = <PricingTable />;
      } else {
        block = <div>New Blocks Coming Soon</div>;
      }
      break;
    default:
      block = null;
  }
  return block;
};

export default Block;
